import Footer from 'component/Footer';
import ProductView from 'component/ProductView';
import SimilarProduct from 'component/SimilarProduct';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import service from 'services/service';
import { globalStore } from 'stores/globalStore';
import SEO from 'component/SEO/SEO';
import "./productDetails.css"

const ProductDetailsPage = () => {
  const { id } = useParams(); 
  const { productDetailsPageData, setProductDetailsPageData } = globalStore();

  const fetchAllData = async () => {
    try {
      
      const [productDetailsResponse, similarProductsResponse] = await Promise.all([
        service.getProductDetailsById(id), 
        service.getSimilarProduct("Cargo"), 
      ]);
  
      setProductDetailsPageData({
        productDetails: productDetailsResponse.data.data,
        similarProducts: similarProductsResponse.data.data, 
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  


  useEffect(() => {
    fetchAllData();
  }, [id]); 

  return (
    <>
      {productDetailsPageData?.productDetails && (
        <SEO
          title={productDetailsPageData.productDetails.name}
          description={productDetailsPageData.productDetails.description}
          url={`/product/${id}`}
          image={productDetailsPageData.productDetails.primaryImage}
          product={productDetailsPageData.productDetails}
        />
      )}
      <ProductView />
    </>
  );
};

export default ProductDetailsPage;
